export const NON_SERIALIZABLE_URLS = ['/files/signed_url'];

export const HOME_PAGE = 'https://www.galgo.com/cl';
export const MARKETPLACE_PAGE = 'https://www.galgo.com/cl/motos';
export const GOOGLE_PLAY_STORE = 'https://play.google.com/store/apps/details?id=com.migrante';
export const APP_STORE = 'https://apps.apple.com/ar/app/migrante/id1571846260';
export const WHATSAPP_SHARE_LINK = 'https://api.whatsapp.com/send?text=';
export const UNIQUE_KEY_RECOVER_PASSWORD = 'https://claveunica.gob.cl/recuperar';
